import { apiServiceClient } from "../config/api";

export const galeriaService = {
  async listByNucleo(nucleoId, filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        params.append(key, String(value));
      }
    });
    const query = params.toString();
    return apiServiceClient.get(`/api/galeria/nucleos/${nucleoId}${query ? `?${query}` : ""}`);
  },

  async listByGrupo(grupoId, filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        params.append(key, String(value));
      }
    });
    const query = params.toString();
    return apiServiceClient.get(`/api/galeria/grupos/${grupoId}${query ? `?${query}` : ""}`);
  },

  async uploadMidia(payload) {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    });
    return apiServiceClient.post("/api/galeria/midias/upload", formData);
  },

  async createMidia(payload) {
    return apiServiceClient.post("/api/galeria/midias", payload);
  },

  async updateMidia(id, data) {
    return apiServiceClient.patch(`/api/galeria/midias/${id}`, data);
  },

  async deleteMidia(id) {
    return apiServiceClient.delete(`/api/galeria/midias/${id}`);
  },
};

export default galeriaService;
